/*
  Iter122k131 · Contenitore filtri richiudibile a tendina, riusabile.
  Espone: header con chevron + titolo + badge contatore filtri attivi + link "Azzera"
  (visibili solo se count>0). Renderizza `children` solo quando aperto.
  Default: chiuso — libera spazio verticale su mobile.
*/
import { ChevronDown, ChevronRight, Search } from "lucide-react";

export function FiltriCollapsible({ open, setOpen, count = 0, onReset, testidPrefix = "filtri",
                                     title = "Ricerca & Filtri", right = null, children }) {
  return (
    <div className="bg-white rounded-xl border-2 border-slate-200 p-3 space-y-3">
      <div className="flex items-center gap-2 flex-wrap">
        <button type="button" data-testid={`${testidPrefix}-filtri-toggle`}
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 text-xs font-bold uppercase text-slate-600 hover:text-slate-900 transition-colors"
          aria-expanded={open}>
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          <Search className="w-4 h-4" /> {title}
          {count > 0 && (
            <span data-testid={`${testidPrefix}-filtri-count`}
              className="ml-1 text-[10px] font-bold bg-indigo-600 text-white rounded-full px-1.5 py-0.5">
              {count}
            </span>
          )}
        </button>
        {count > 0 && (
          <button type="button" data-testid={`${testidPrefix}-filtri-reset`}
            onClick={onReset}
            className="text-[10px] font-semibold text-red-700 hover:text-red-900 underline">
            Azzera
          </button>
        )}
        {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
      </div>
      {open && children}
    </div>
  );
}
